@if (showChips() && multiple()) {
  <div class="chips-container">
    @for (selectedItem of selectedList(); track selectedItem) {
      <mat-chip [removable]="!selectedControl.disabled" (removed)="removeChip(selectedItem)">
        <div class="chip-text">
          {{ displayKey() ? selectedItem[displayKey()!] : selectedItem }}
        </div>

        @if (!selectedControl.disabled) {
          <mat-icon matChipRemove>close</mat-icon>
        }
      </mat-chip>
    }
  </div>
}

<mat-form-field>
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <mat-select
    #mySelect
    [formControl]="selectedControl"
    [multiple]="multiple()"
    (openedChange)="onOpenChange($event)"
    [compareWith]="compareWith"
  >
    <mat-select-trigger>
      {{ displayKey() ? (selectedList()[0] ? selectedList()[0][displayKey()!] : '') : selectedList()[0] || '' }}
      @if ((selectedList().length || 0) > 1) {
        <span class="example-additional-selection">
          (+{{ (selectedList().length || 0) - 1 }} {{ selectedList().length === 2 ? 'other' : 'others' }})
        </span>
      }
    </mat-select-trigger>

    @if (optionList().length !== 0) {
      <div class="m-filter">
        @if (multiple() && showSelectAll()) {
          <mat-checkbox
            [checked]="allFilteredSelected()"
            [indeterminate]="someFilteredSelected()"
            (change)="toggleSelectAll(mySelect)"
            (click)="$event.stopPropagation()"
          />
        }

        <mat-form-field appearance="outline" class="m-filter-form-field">
          <mat-label>Filter</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="value"
            [ngModelOptions]="{ standalone: true }"
            (keydown.space)="$event.stopPropagation()"
          />
          @if (value()) {
            <button
              type="button"
              style="position: absolute; right: -10px; top: 8px"
              mat-icon-button
              aria-label="Clear"
              (click)="value.set('')"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>

        @if (multiple() && selectedList().length > 0) {
          <button type="button" matTooltip="Remove all selected" mat-icon-button aria-label="Clear" (click)="clearAll(mySelect)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        }
      </div>
    }

    <cdk-virtual-scroll-viewport
      #viewport
      itemSize="48"
      style="width: 100%"
      [style.height.px]="viewportHeight()"
      minBufferPx="250"
      maxBufferPx="500"
    >
      @if (loading()) {
        <mat-option disabled>Loading...</mat-option>
      } @else {
        @if (!multiple() && unselect()) {
          <!-- option for unselect when single select -->
          <mat-option>-</mat-option>
        }

        @if (optionList().length === 0) {
          <mat-option disabled>No options available</mat-option>
        }

        <!-- mat SelectionModel keeps track of options in list not to lose selected optinos which are not rendered we render them and hide  -->
        @for (option of hiddenOptions(); track option) {
          <!-- IMPORTANT! Keep the content of 'mat-option' the same -->
          <mat-option [value]="option" [style.display]="'none'">{{ option }} </mat-option>
        }

        <mat-option #virtualOption *cdkVirtualFor="let option of filteredList()" [value]="option">
          {{ displayKey() ? option[displayKey()!] : option }}
        </mat-option>
      }
    </cdk-virtual-scroll-viewport>
  </mat-select>
  @for (entry of filterErrorMessages(selectedControl.errors); track entry.key) {
    <mat-error>{{ entry.message }}</mat-error>
  }
</mat-form-field>
